// extracted by mini-css-extract-plugin
module.exports = {"CartIndicator":"CartIndicators_CartIndicator__1qANM","CrosshairX":"CartIndicators_CrosshairX__3B3Qs","CrosshairY":"CartIndicators_CrosshairY__2ZQEU"};